























































import CandidateAssessment from '@/domain/selective-process/entity/assessment/assessment.entity';
import PaginationComponent from '@/shared/pagination.component.vue';
import MobileHandler from '@/shared/utils/mobile-handler';
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import debounce from '@/shared/utils/debounce';
import DrawerComponent from '@/shared/drawer/drawer.component.vue';
import Headers from './selective-process-table-headers.json';
import CandidateResultDetails from './candidate/candidate-result-datails.view.vue';

@Component({
  components: {
    PaginationComponent,
    DrawerComponent,
    CandidateResultDetails,
  },
})
export default class SelectiveProcessTable extends Vue {
  @Prop() assessments!: CandidateAssessment[];

  @Prop({
    type: Boolean,
  }) loading!: boolean;

  @Prop() page!: any;

  headers = Headers;

  openModal: boolean = false;

  assessmentSelected = new CandidateAssessment();

  keyItemSelected: number = -1;

  isMobile = false;

  showDrawer: boolean = false;

  openCandidate(item: CandidateAssessment) {
    this.assessmentSelected = item;
    this.showDrawer = true;
  }

  closeModal(event: any) {
    this.openModal = event;
  }

  onResize() {
    this.isMobile = MobileHandler.isMobile();
  }

  @Watch('page.sortBy')
  onSortByChanged() {
    this.updateDebouce();
  }

  @Watch('page.sortDesc')
  onSortDescChanged() {
    this.updateDebouce();
  }

  updateDebouce() {
    debounce.debounce(() => this.updateTable(this.page), 50);
  }

  updateTable(pagination: any) {
    this.$emit('update', pagination)
  }

  getPercentageFormatted(value: number): string {
    return value !== null && value !== undefined ? `${value.toFixed(2)}%` : '-';
  }
}
